module.exports = __webpack_public_path__ + "static/media/bitJob.82805a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/bitJob.png
// module id = 1850
// module chunks = 147